<template>
  <modal :active="active" @close="handleCloseModal">
    <div slot="title">Upload New Media File</div>
    <vue-clip
      :options="uploaderOptions"
      class="uploader"
      :on-queue-complete="queueCompleted"
    >
      <template slot="clip-uploader-action" slot-scope="props">
        <div class="row">
          <div
            v-bind:class="{ dragging: props.dragging }"
            class="uploader-action col-md-12"
          >
            <div class="dz-message">Drag and Drop file here or browse</div>
          </div>
        </div>
      </template>
      <template slot="clip-uploader-body" slot-scope="props">
        <div class="row uploader-files">
          <div
            class="col-md-4 text-center uploader-file"
            :key="file.name"
            v-for="file in props.files"
          >
            <div class="file-avatar">
              <img
                style="
                  object-fit: contain;
                  display: block;
                  max-height: 100%;
                  max-width: 100%;
                "
                :src="file.dataUrl"
                alt=""
              />
            </div>
            <div class="file-details">
              <div class="file-name">
                <p>{{ file.name }}</p>
              </div>

              <div class="file-progress">
                <span
                  class="progress-indicator"
                  v-bind:style="{ width: file.progress + '%' }"
                ></span>
              </div>

              <div class="file-meta">
                <span class="file-size">{{ bytesToSize(file.size) }}</span>
                <span class="file-status">{{ file.status }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </vue-clip>
  </modal>
</template> 
 <script>
import Spinner from "vue-simple-spinner";
import Modal from "../../components/Modal.vue";
import MediaFileStorer from "../../storers/StoreMediaFile";
import { mapState } from "vuex";
export default {
  data() {
    return {
      maxFilesLimit: 30,
      maxFileSizeLimit: 20,
      extensions: [
        ".jpg",
        ".jpeg",
        ".png",
        ".mp4",
        ".wav",
        ".flv",
        ".3gp",
        ".avi",
        ".wmv",
        ".vob",
        ".mp3",
        ".pptx",
        ".docx",
        ".doc",
        ".pdf",
        ".svg"
      ],
    };
  },
  props: {
    active: Boolean,
  },
  components: { Spinner, Modal },
  created: function () {},
  computed: {
    uploaderOptions() {
      var mediaStore = MediaFileStorer();

      return {
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + this.token,
        },
        url: "/api/media-files/create",

        paramName: "file",
        parallelUploads: 1,
        maxFilesize: {
          limit: this.maxFileSizeLimit,
          message:
            "Maximum number of files size is: " + this.maxFileSizeLimit + " MB",
        },
        uploadMultiple: false,
        maxFiles: {
          limit: this.maxFilesLimit,
          message: "Maximum number of files is: " + this.maxFilesLimit,
        },
        acceptedFiles: {
          extensions: this.extensions,
          message: "You are uploading an invalid file",
        },
      };
    },
    ...mapState({
      token: (state) => state.userStore.token,
    }),
  },
  methods: {
    init() {},
    handleCloseModal() {
      this.init();
      this.$emit("closeRequest");
    },
    queueCompleted() {
      this.$emit("finished");
    },
    handleSave() {
      var mediaFile = MediaFileStorer();

      this.$emit("saveRequest", mediaFile);
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
  },
  watch: {},
};
</script> 
 <style>
.modal-body {
  min-height: 250px !important;
}
.image-upload > input {
  display: none;
}
.uploader-action {
  padding: 5px 7px 15px 7px;
  background-color: white;
  cursor: pointer;
  transition: background 300ms ease;
  width: 100%;
}
.uploader {
  min-height: 500px;
  border-radius: 6px;
  min-height: 200px;
}

.uploader * {
  box-sizing: border-box;
}
.uploader-file .file-progress {
  width: 100%;
  height: 5px;
}
.uploader-file .file-progress .progress-indicator {
  background: yellowgreen;
  display: flex;
  height: 5px;
}
.uploader-action .dz-message {
  color: #94a7d2;
  text-align: center;
  padding: 20px 40px;
  border: 3px dashed #dfe8fe;
  border-radius: 4px;
  font-size: 16px;
}
.file-avatar {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/common/FileUploader.vue